import React from 'react';
import { Carousel } from 'antd';
import 'antd/dist/antd.css';

const LoginCarousel = ({ images = [], imageList = [], sliderImageURL = '' }) => {
    try {
        return (
            <div className='logo'>
                <Carousel autoplay autoplaySpeed={5000}>
                    {(imageList.length !== 0 ? imageList : images).map((item, i) => {
                        const imgSrc = imageList.length !== 0
                            ? sliderImageURL.replace('info.json', item.image)
                            : item;

                        const imgAlt = item.text || `slide-${i}`;
                        const imgLink = item.link || null;

                        return (
                            <div key={i} style={{ height: '200px' }}>
                                <img
                                    src={imgSrc}
                                    alt={imgAlt}
                                    width="805"
                                    height="610"
                                    title={imgAlt}
                                    onClick={() => {
                                        if (imgLink) {
                                            window.open(imgLink, '_blank');
                                        }
                                    }}
                                />
                            </div>
                        );
                    })}
                </Carousel>
            </div>
        );
    } catch (ex) {
        console.error('LoginCarousel Error:', ex.message, ex.stack);
        throw new Error('Login Slider Crashed!');
    }
};

export default LoginCarousel;
